import awsdk from 'awsdk';

// FULLNAME
// INITIAL
// NONE

export const ConsumerMiddleNameHandling = awsdk.AWSDKConsumerMiddleNameHandling;
export type ConsumerMiddleNameHandling = typeof ConsumerMiddleNameHandling;
